import { Component } from "vue-property-decorator";
import axios from "axios";
// Components
import IdeaBox from "../IdeaBox.vue";
// Entities
import SuperView from "@/entities/models/SuperView";
import { Profile } from "@/entities/index";

@Component({
  components: {
    IdeaBox,
  },
})
export default class Navbar extends SuperView {
  drawer = false;
  selectedItem = 0;

  links = [
    {
      icon: "mdi-chart-arc",
      text: this.$t("nav.dashboard"),
      route: "/dashboard",
    },
    { icon: "mdi-warehouse", text: this.$t("nav.stock"), route: "/stock" },
    {
      icon: "mdi-calendar-clock",
      text: this.$t("nav.preparation"),
      route: "/preparation",
    },
    {
      icon: "mdi-truck-fast",
      text: this.$t("nav.transport"),
      route: "/suiviTransport",
    },
    { icon: "settings", text: this.$t("nav.settings"), route: "/parametres" },
  ];

  // ========== GETTERS ========== //

  get filteredLinks() {
    const userIsAdmin = this.$store.getters.role === "admin";
    const disabledRoute = this.$store.getters.company.disabledRoute;
    const transportByTempo = this.$store.getters.transportByTempo;

    return this.links.filter((link) => {
      if (link.route === "/parametres" && !userIsAdmin) {
        return false;
      }

      if (
        (link.route === "/preparation" &&
          disabledRoute.includes("preparation")) ||
        (link.route === "/stock" && disabledRoute.includes("stock")) ||
        (link.route === "/suiviTransport" && transportByTempo.includes("non"))
      ) {
        return false;
      }

      return true;
    });
  }

  async getProfile(): Promise<Profile> {
    const profile = (await axios.get("/api/users/profile")).data as Profile;
    return profile;
  }

  async getCompany(id: number): Promise<Profile> {
    const company = (await axios.get(`/api/companies/${id}`)).data as Profile;
    return company;
  }

  async mounted(): Promise<void> {
    const profile = await this.getProfile();
  }

  // ========== OTHER METHODS ========== //

  showIdea() {
    const idea = this.$refs.ideaBox as any;
    idea.show();
  }

  goToConnect() {
    window.location.replace(`https://connect.tempo-one.com/`);
  }
}
